import { Controller } from "@hotwired/stimulus"

// Copies a data-clipboard-value to the clipboard on click.
// Usage:
//   <button data-controller="clipboard" data-clipboard-value="text to copy"
//           data-action="click->clipboard#copy">Copy</button>
export default class extends Controller {
  static values = { content: String }

  copy() {
    navigator.clipboard.writeText(this.contentValue).then(() => {
      const original = this.element.innerHTML
      this.element.textContent = "Copied!"
      setTimeout(() => { this.element.innerHTML = original }, 1500)
    })
  }
}
